import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Wrapper } from "modules/theme";
import { Alert, confirm } from "modules/theme";
import APIManager from "modules/common/apiManager";
import RcsProviderAddEdit from "./RcsProviderAddEdit";
import { Dropdown, MenuItem } from "react-bootstrap";
import { FiTag } from "react-icons/fi";
import { PerPage } from "helpers/system-config";
import { CustomDropdown } from "modules/common/components";
import {
  ModalTrigger,
  Button,
  ButtonCommonTheme,
  FormControl,
  ActionButtons,
  Table,
  DataWithLoader,
  FormGroup,
  ControlLabel,
  ReportPagination,
  DropdownToggle,
  SeachForm,
  DataWrapperClass,
  Icon,
  SettingDropdownMenu,
} from "modules/theme";
import { modalType } from "../../../../../helpers/dotenv";
import { CenterFlexRow, BackButton } from "../styles";

const defaultColums = ["name", "type", "templete"];
class RcsProvider extends Component {
  constructor(props) {
    super(props);
    this.moduleName = `RCS Provider`;
    this.moduleUrl = `setting/rbmConfig`;
    this.mAPI = new APIManager();
    this.handleModalShowHide = this.handleModalShowHide.bind(this);
    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.onPerPageChooser = this.onPerPageChooser.bind(this);
    this.getList = this.getList.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.search = this.search.bind(this);
    this.handleModalShowColumn = this.handleModalShowColumn.bind(this);
    let selectedColumList = defaultColums;
    this.state = {
      listData: [],
      total: 0,
      currentPage: 1,
      perPageCount: PerPage,
      loading: false,
      editData: null,
      showHide: false,
      modalType: modalType,
      MasterChecked: false,
      SingleChecked: false,
      SelectedList: [],
      ary: [],
      tagList: [],
      search: "",
      assignAry: [],
      tags: [],
      SelectedTagList: [],
      TagChecked: false,
      columnList: defaultColums,
      selectedColumList: selectedColumList,
      showColumnm: false,
    };
    this.getTag();
  }
  componentDidMount() {
    this.getList();
  }

  onMasterCheck(e) {
    let tempList = this.state.listData;

    tempList.map((listData) => (listData.selected = e.target.checked));

    this.setState({
      MasterChecked: e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  handleModalShowColumn() {
    this.setState({ showColumnm: !this.state.showColumnm });
  }

  onItemCheck(e, item) {
    let tempList = this.state.listData;
    tempList.map((user) => {
      if (user._id === item._id) {
        user.selected = e.target.checked;
      }
      return user;
    });

    const totalItems = this.state.listData.length;
    const totalCheckedItems = tempList.filter((e) => e.selected).length;

    this.setState({
      MasterChecked: totalItems === totalCheckedItems && e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  onItemTagCheck(e, item) {
    let tempList = this.state.tagList;
    tempList.map((tag) => {
      if (tag._id === item._id) {
        tag.selectedTag = e.target.checked;
      }
      return tag;
    });

    console.log(
      "filter",
      this.state.tagList.filter((e) => e.selectedTag)
    );
    this.setState({
      TagChecked: e.target.checked,
      tagList: tempList,
      SelectedTagList: this.state.tagList.filter((e) => e.selectedTag),
    });
  }

  closeModal(isUpdated) {
    this.setState({ showHide: false });
    if (isUpdated) {
      this.getList(this.state.currentPage, this.state.perPageCount, this.state.search);
    }
  }
  openModal(data) {
    if (data) {
      this.setState({ showHide: true, editData: data });
    } else {
      this.setState({ showHide: true, editData: undefined });
    }
  }

  handleModalShowHide(data) {
    this.setState({ showHide: !this.state.showHide });
  }

  getList(page = 1, perPage = "", searchText = "") {
    var that = this;
    this.setState({ loading: true });
    perPage = perPage || this.state.perPageCount;
    this.mAPI.sendGetAPI(
      `${this.moduleUrl}?limit=${perPage}&page_no=${page}&search=${searchText}&orderBy=create_at&order=DESC`,
      (data) => {
        this.setState({ loading: false });
        if (data && data.data) {
          const newData = data.data.map((i) => ({ ...i, selected: false }));
          that.setState({
            listData: newData,
            total: data.count || 0,
            SelectedList: [],
            MasterChecked: false,
          });
        }
      },
      (error, data) => {
        if (data) {
          Alert.error(` ${data.message}`);
        } else {
          Alert.error(`${error}`);
        }
      }
    );
  }

  getTag() {
    var that = this;

    this.mAPI.sendGetAPI(
      `setting/tag?limit=10&page_no=1`,
      (data) => {
        if (data && data.data) {
          that.setState({ tagList: data.data });
        } else {
          that.setState({ tagList: [] });
        }
      },
      (error, data) => {}
    );
  }

  onPaginationChange(page) {
    this.setState({ currentPage: page });
    this.getList(page, "", this.state.search);
  }

  onPerPageChooser(perPage) {
    this.setState({ currentPage: 1 });
    this.setState({ perPageCount: perPage });
    this.getList(1, perPage);
  }

  remove(array, key, value) {
    const index = array.findIndex((obj) => obj[key] === value);
    return index >= 0
      ? [...array.slice(0, index), ...array.slice(index + 1)]
      : array;
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  deleteData(data) {
    var that = this;
    this.mAPI.sendPostAPI(
      `${this.moduleUrl}/${data._id}`,
      undefined,
      (data) => {
        let tD = that.state.listData;
        tD = that.remove(tD, "_id", data._id);
        that.setState({ listData: tD });
        this.getList();
        Alert.success(`${this.moduleName} deleted successfully`);
      },
      (errorCode, data) => {
        Alert.error(`errorCode : ${data.message}`);
      },
      "private",
      {},
      "DELETE"
    );
  }

  deleteAllData(e) {
    let _this = this;
    e.preventDefault();

    const list = this.state.SelectedList.map((data) => {
      this.state.ary.push(data._id);
    });
    this.mAPI.sendPostAPI(
      `${this.moduleUrl}/multiple/usingIds`,
      {
        ids: this.state.ary,
      },
      (data) => {
        this.getList();
        Alert.success(`${this.moduleName} deleted successfully`);
      },
      (errorCode, data) => {
        Alert.error(`errorCode : ${data}`);
      },
      `private`,
      {},
      "PUT"
    );
  }

  assignTag(e) {
    const list = this.state.SelectedList.map((data) => {
      this.state.assignAry.push(data._id);
    });
    const tag = this.state.SelectedTagList.map((data) => {
      this.state.tags.push(data.name);
    });
    let tData = {
      module_ids: this.state.assignAry,
      module_name: this.moduleName,
      tags: this.state.tags,
    };
    this.mAPI.sendPostAPI(
      `setting/tag`,
      tData,
      (data) => {},
      (errorCode, data) => {
        Alert.error(`errorCode : ${data}`);
      },
      `private`,
      {},
      "PUT"
    );
  }

  onChange() {}

  onSingleChange(e, company) {}

  edit(data) {
    return (
      <ButtonCommonTheme type="edit" editOnClick={() => this.openModal(data)} />
    );
  }

  renderActions(data, index) {
    return (
      <ActionButtons>
        {this.edit(data)}
        <CustomDropdown
          index={index}
          totalLength={this.state.listData.length || 0}
        >
          <MenuItem
            style={{ marginLeft: "0px" }}
            onClick={(e) =>
              confirm().then((e) => {
                this.deleteData(data, e);
              })
            }
          >
            {"Delete"}
          </MenuItem>
        </CustomDropdown>
      </ActionButtons>
    );
  }

  moveCursorAtTheEnd(e) {
    const tmpValue = e.target.value;
    e.target.value = "";
    e.target.value = tmpValue;
  }

  search(e) {
    let value;
    value = e.target.value;
    const reg = /^[a-zA-Z0-9_ @]*$/;
    if (reg.test(value)) {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.setState({ search: value, currentPage: 1 });
        this.getList(1, this.state.perPageCount, value);
      }, 500);
    }
  }

  renderActionBar() {
    const ImportTrigger = ({ onClick }) => {
      return <ButtonCommonTheme type="add" addOnClick={onClick} />;
    };
    return (
      <span style={{ display: "flex", whiteSpace: "nowrap" }}>
        <ModalTrigger
          title={this.moduleName}
          trigger={<ImportTrigger />}
          size="md"
          showHide={this.state.showHide}
          closeModal={this.closeModal}
          openModal={this.openModal}
          dialogClassName={this.state.modalType}
        >
          <RcsProviderAddEdit
            update={() => this.setState({ currentPage: 1 })}
            size="small"
            isEdit={false}
            ProviderList={this.state.ProviderList}
            TeamList={this.state.TeamList}
            UsersList={this.state.UsersList}
            editData={this.state.editData}
            modalType={this.state.modalType}
            closeModal={this.closeModal}
          />
        </ModalTrigger>
      </span>
    );
  }

  render() {
    const { __ } = this.context;
    const breadcrumb = [
      { title: __("Settings"), link: "/settings" },
      { title: __("RCS Provider"), link: "/settings/rcs-provider" },
    ];

    const mainContent = (
      <DataWrapperClass overflow="nohide" className="tableFixHeadSecondary">
        <Table whiteSpace="nowrap" bordered hover>
          <thead>
            <tr>
              <th>
                <FormControl
                  componentClass="checkbox"
                  checked={this.state.MasterChecked}
                  onChange={(e) => this.onMasterCheck(e)}
                />
              </th>
              <th>{__("name")}</th>
              <th>{__("Action")}</th>
            </tr>
          </thead>
          <tbody>
            {this.state.listData.map((data, index) => (
              <tr key={data._id}>
                <td onClick={this.onClick}>
                  <FormControl
                    componentClass="checkbox"
                    checked={data.selected}
                    onChange={(e) => this.onItemCheck(e, data)}
                  />
                </td>
                <td>{data.name}</td>
                <td>{this.renderActions(data, index)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </DataWrapperClass>
    );

    return (
      <div className="heightClass">
        <DataWrapperClass>
          <Wrapper
            header={<Wrapper.Header breadcrumb={breadcrumb} />}
            heading={
              <CenterFlexRow className="header-label">
                <Link className="btn-back" to={`/settings`}>
                  <BackButton>
                    <Icon icon="angle-left" size={20} />
                  </BackButton>
                </Link>
                <ControlLabel>{this.moduleName}</ControlLabel>
              </CenterFlexRow>
            }
            actionBar={
              <Wrapper.ActionBar
                left={
                  <div style={{ display: "flex" }}>
                    <SeachForm className="mr-5">
                      <FormControl
                        type="text"
                        placeholder={"Search Here"}
                        onChange={(e) => this.search(e)}
                        value={this.state.searchValue}
                        autoFocus={false}
                      />
                      <span className="material-symbols-outlined">search</span>
                    </SeachForm>
                    {this.state.SelectedList.length > 0 && (
                      <ButtonCommonTheme
                        type="deleteAll"
                        checkboxDeleteOnClick={(e) =>
                          confirm().then((e) => {
                            this.deleteAllData(e);
                          })
                        }
                      />
                    )}
                    {/* {
						this.state.SelectedList.length === 1 && (
						<Dropdown id='dropdown-engage'>
							<DropdownToggle bsRole='toggle'>
							<Button
								btnStyle='simple'
								size='small'
								style={{ marginLeft: '10px' }}
							>
								<FiTag
								style={{ fontSize: '14px', marginBottom: '-3px' }}
								/>{' '}
								Tag
							</Button>
							</DropdownToggle>
							<Dropdown.Menu>
                          <li>
                            {this.state.tagList.map((data) => (
                              <a>
                                <div>
                                  <FormControl
                                    componentClass='checkbox'
                                    checked={data.selectedTag}
                                    onChange={(e) =>
                                      this.onItemTagCheck(e, data)
                                    }
                                  />
                                  <FiTag
                                    style={{
                                      fontSize: '14px',
                                      marginBottom: '-3px',
                                      color: data.colourCode,
                                    }}
                                  />{' '}
                                  {data.name}
                                </div>
                              </a>
                            ))}
                          </li>
                        </Dropdown.Menu>
                      </Dropdown>
                    )
					*/}
                  </div>
                }
                right={this.renderActionBar()}
              />
            }
            footer={
              <ReportPagination
                count={this.state.total}
                onPaginationChange={this.onPaginationChange}
                onPerPageChooser={this.onPerPageChooser}
                currentPage={this.state.currentPage}
                perPage={this.state.perPageCount}
              />
            }
            leftSidebar={<SettingDropdownMenu />}
            showLeftSideBar={true}
            content={
              <div>
                <DataWithLoader
                  data={mainContent}
                  loading={this.state.loading}
                  size={this.state.listData.length}
                  count={this.state.listData.length}
                  emptyText={`Sorry..! No ${this.moduleName} Found`}
                  emptyImage="/images/emptyimg.png"
                />
              </div>
            }
          />
        </DataWrapperClass>
      </div>
    );
  }
}

RcsProvider.contextTypes = {
  __: PropTypes.func,
};

export default RcsProvider;



// WEBPACK FOOTER //
// src/modules/screens/settings/RcsProvider/components/RcsProvider.js